<template>
  <div class="contract-type-spec-manage-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">
          <span class="title-light">{{ $t('contractTypeSpecManage.table.title') }}</span>
          <img src="/assets/CodeBuddyAssets/616_44267/33.svg" class="title-arrow" />
          <span class="title-dark">{{ typeName }}</span>
        </div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-add" @click="handleAdd">
              <i class="el-icon-plus"></i>{{ $t('common.add') }}
            </el-button>
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="getList">
              <i class="el-icon-refresh-right"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input
              v-model="searchForm.specCd"
              size="small"
              :placeholder="$t('contractTypeSpecManage.search.specCd')"
              class="figma-search-input"
              clearable
              @keyup.enter.native="handleSearch"
            />
            <el-input
              v-model="searchForm.specName"
              size="small"
              :placeholder="$t('contractTypeSpecManage.search.specName')"
              class="figma-search-input"
              clearable
              @keyup.enter.native="handleSearch"
            />
            <el-select
              v-model="searchForm.specShow"
              size="small"
              :placeholder="$t('contractTypeSpecManage.search.specShow')"
              class="figma-search-select"
              clearable
              @change="handleSearch"
            >
              <el-option :label="$t('contractTypeSpecManage.search.all')" value="" />
              <el-option :label="$t('contractTypeSpecManage.search.yes')" value="Y" />
              <el-option :label="$t('contractTypeSpecManage.search.no')" value="N" />
            </el-select>
            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column prop="specCd" :label="$t('contractTypeSpecManage.table.specCd')" min-width="286" show-overflow-tooltip />
          <el-table-column prop="specName" :label="$t('contractTypeSpecManage.table.specName')" min-width="250" show-overflow-tooltip />
          <el-table-column prop="required" :label="$t('contractTypeSpecManage.table.required')" min-width="146" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.required === 'Y' ? $t('common.yes') : $t('common.no') }}
            </template>
          </el-table-column>
          <el-table-column prop="specShow" :label="$t('contractTypeSpecManage.table.specShow')" min-width="158" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.specShow === 'Y' ? $t('common.yes') : $t('common.no') }}
            </template>
          </el-table-column>
          <el-table-column prop="specValueType" :label="$t('contractTypeSpecManage.table.specValueType')" min-width="158" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatSpecValueType(scope.row.specValueType) }}
            </template>
          </el-table-column>
          <el-table-column prop="specType" :label="$t('contractTypeSpecManage.table.specType')" min-width="224" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatSpecType(scope.row.specType) }}
            </template>
          </el-table-column>
          <el-table-column prop="listShow" :label="$t('contractTypeSpecManage.table.listShow')" min-width="192" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.listShow === 'Y' ? $t('common.yes') : $t('common.no') }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('contractTypeSpecManage.table.operation')" min-width="166" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="action-links">
                <a class="action-link" @click="handleEdit(scope.row)">{{ $t('common.edit') }}</a>
                <span class="link-space"></span>
                <a class="action-link" @click="handleDelete(scope.row)">{{ $t('common.delete') }}</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination-section">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pagination.total"
          :current-page="pagination.current"
          :page-size="pagination.size"
          @current-change="handleCurrentChange"
        />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <add-contract-type-spec ref="addDialog" @success="handleSuccess" />
    <edit-contract-type-spec ref="editDialog" @success="handleSuccess" />
    <delete-contract-type-spec ref="deleteDialog" @success="handleSuccess" />
  </div>
</template>

<script>
import { queryContractTypeSpec } from '@/api/contract/contractTypeSpecManageApi'
import AddContractTypeSpec from '@/components/contract/addContractTypeSpec'
import EditContractTypeSpec from '@/components/contract/editContractTypeSpec'
import DeleteContractTypeSpec from '@/components/contract/deleteContractTypeSpec'

export default {
  name: 'ContractTypeSpecManageList',
  components: {
    AddContractTypeSpec,
    EditContractTypeSpec,
    DeleteContractTypeSpec
  },
  data() {
    return {
      loading: false,
      searchForm: {
        specCd: '',
        specName: '',
        specShow: '',
        contractTypeId: this.$route.query.contractTypeId || ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      typeName: this.$route.query.typeName || ''
    }
  },
  created() {
    this.getList()
  },
  methods: {
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      const base = { color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px', fontWeight: rowIndex % 2 === 1 ? '500' : '400' }
      return rowIndex % 2 === 1 ? { ...base, background: '#F8FBFF' } : { ...base, background: 'white' }
    },
    async getList() {
      try {
        this.loading = true
        const params = {
          ...this.searchForm,
          page: this.pagination.current,
          row: this.pagination.size
        }
        const { data, total } = await queryContractTypeSpec(params)
        this.tableData = data
        this.pagination.total = total
      } catch (error) {
        this.$message.error(this.$t('contractTypeSpecManage.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.pagination.current = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    },
    handleAdd() {
      this.$refs.addDialog.open({
        contractTypeId: this.searchForm.contractTypeId
      })
    },
    handleEdit(row) {
      this.$refs.editDialog.open(row)
    },
    handleDelete(row) {
      this.$refs.deleteDialog.open(row)
    },
    handleSuccess() {
      this.getList()
    },
    formatSpecValueType(type) {
      const map = {
        '1001': this.$t('contractTypeSpecManage.specValueType.string'),
        '2002': this.$t('contractTypeSpecManage.specValueType.integer'),
        '3003': this.$t('contractTypeSpecManage.specValueType.amount'),
        '4004': this.$t('contractTypeSpecManage.specValueType.date'),
        '5005': this.$t('contractTypeSpecManage.specValueType.time')
      }
      return map[type] || type
    },
    formatSpecType(type) {
      const map = {
        '2233': this.$t('contractTypeSpecManage.specType.input'),
        '3344': this.$t('contractTypeSpecManage.specType.select')
      }
      return map[type] || type
    }
  }
}
</script>

<style scoped>
.contract-type-spec-manage-container { padding: 20px; height: 100%; box-sizing: border-box; }
.figma-white-card { background: white; border-radius: 12px; height: 100%; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px 12px; gap: 12px; flex-shrink: 0; }
.figma-page-title { font-size: 16px; font-weight: 600; color: #1D2129; font-family: 'PingFang SC'; line-height: 22px; display: flex; align-items: center; gap: 8px; }
.title-light { color: #8C9BB4; }
.title-dark { color: #1D2129; }
.title-arrow { width: 16px; height: 16px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.figma-btn-group { display: flex; align-items: center; gap: 12px; }
.figma-btn-add { width: 82px; height: 38px; background: #0E76FF !important; border-color: #0E76FF !important; color: white !important; border-radius: 10px !important; font-size: 14px; font-weight: 500; }
.figma-btn-add i { margin-right: 6px; }
.figma-btn-refresh { width: 38px; height: 38px; padding: 0 !important; background: white !important; border-color: #DCE6F5 !important; color: #364153 !important; border-radius: 10px !important; }
.figma-search-group { display: flex; align-items: center; gap: 12px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input ::v-deep .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; background: white; color: #1D2129; }
.figma-search-input ::v-deep .el-input__inner:focus { outline-color: #0E76FF; }
.figma-search-input ::v-deep .el-input__inner::placeholder { color: #8C9BB4; }
.figma-search-select { width: 256px; height: 38px; }
.figma-search-select ::v-deep .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; font-size: 14px; background: white; color: #1D2129; }
.figma-search-select ::v-deep .el-input__inner:focus { outline-color: #0E76FF; }
.figma-search-select ::v-deep .el-input__inner::placeholder { color: #8C9BB4; }
.figma-btn-search { width: 84px; height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; }
.figma-btn-search i { margin-right: 4px; }
.figma-table-section { flex: 1; padding: 12px 24px 0; overflow: auto; }
.figma-table-section ::v-deep .el-table { border-radius: 8px; overflow: hidden; border: none; }
.figma-table-section ::v-deep .el-table::before { display: none; }
.figma-table-section ::v-deep .el-table__header th { background: #EBF2FA !important; border: none !important; }
.figma-table-section ::v-deep .el-table__body td { border: none !important; }
.action-links { display: flex; align-items: center; justify-content: center; white-space: nowrap; }
.action-link { color: #0E76FF; font-size: 14px; cursor: pointer; text-decoration: none; font-weight: 400; }
.action-link:hover { opacity: 0.85; }
.link-space { width: 12px; display: inline-block; }
.figma-pagination-section { display: flex; align-items: center; justify-content: flex-end; padding: 16px 24px 24px; gap: 8px; flex-shrink: 0; }
.pagination-total { font-size: 14px; color: #1D2129; margin-right: 4px; }
.figma-pagination-section ::v-deep .el-pagination { display: flex; align-items: center; padding: 0; }
.figma-pagination-section ::v-deep .btn-prev,
.figma-pagination-section ::v-deep .btn-next { width: 32px; height: 32px; border-radius: 2px; background: white; }
.figma-pagination-section ::v-deep .el-pager li { min-width: 32px; height: 32px; line-height: 32px; border-radius: 8px; color: #1D2129; font-weight: 600; }
.figma-pagination-section ::v-deep .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.pagination-size-select { width: 92px; margin-left: 8px; }
.pagination-size-select ::v-deep .el-input__inner { height: 32px; border-radius: 8px; background: #F2F3F5; border: none; font-size: 14px; color: #1D2129; }

@media (max-width: 1024px) {
  .figma-header-row { align-items: flex-start; gap: 12px; flex-direction: column; }
  .figma-btn-group { flex-wrap: wrap; }
  .figma-search-group { width: 100%; margin-left: 0; flex-wrap: wrap; }
  .figma-search-input { width: min(256px, calc(100vw - 150px)); }
  .figma-search-select { width: min(256px, calc(100vw - 150px)); }
}
</style>
